import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { BaseQueryOpts } from '../baseTypes';
import { createAddendum, getAddendaBySessionId } from '@uplift/api';


export const useAddendaBySessionIdQuery = (sessionId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'session', sessionId, 'addenda' ],
    queryFn: async () => {
      const response = await getAddendaBySessionId(sessionId);

      return response.data;
    },
    ...opts
  });
};


export const useAddAddendumForSessionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: { sessionId: string; content: string; submittedBillingUpdate: boolean }) => {
      const response = await createAddendum(params.sessionId, {
        content: params.content,
        submittedBillingUpdate: params.submittedBillingUpdate,
      });

      return response.data;
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries([ 'session', variables.sessionId, 'addenda' ]);
    }
  });
};
